import { render, staticRenderFns } from "./MenuItemIndex.vue?vue&type=template&id=248afbee&scoped=true"
import script from "./MenuItemIndex.vue?vue&type=script&lang=js"
export * from "./MenuItemIndex.vue?vue&type=script&lang=js"
import style0 from "./MenuItemIndex.vue?vue&type=style&index=0&id=248afbee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248afbee",
  null
  
)

export default component.exports